const config = {
    apiKey: "AIzaSyCr24EfY81mpT0MJx7tvkAzQUvCJPiJhD4",
    authDomain: "better-banking-c614b.firebaseapp.com",
    databaseURL: "https://better-banking-c614b.firebaseio.com",
    projectId: "better-banking-c614b",
    storageBucket: "better-banking-c614b.appspot.com",
    messagingSenderId: "301515208758",
    appId: "1:301515208758:web:85b291fed0706a8f8cc097"
};

export default config;